<!-- 全版面刪除 loading overlay -->
<div *ngIf="isDeleting" class="fullpage-loading-overlay">
  <div class="loading-content">
    <i class="fa fa-spinner fa-spin fa-3x"></i>
    <div style="margin-top: 16px;">刪除中，請稍候...</div>
  </div>
</div>
<!-- 頂部選單區塊 -->
<div class="top-filter-container" *ngIf="!dataLoaded">
  <div class="filter-row">
    <!-- 主題選擇 -->
<div class="filter-item">
  <label for="topicFilter">主題:</label>
  <select id="topicFilter" [(ngModel)]="selectedTopicFilter" (change)="onTopicChange()" [disabled]="!selectedCompanyId">
    <option value="">-- 請選擇主題 --</option>
    <option *ngFor="let topic of getAvailableTopics()" [value]="topic">{{ topic }}</option>
  </select>
</div>


  </div>
</div>

<!-- 任務列表區塊 (當有公司和主題選擇但未選擇任務時顯示) -->
<div *ngIf="tasksLoaded && !dataLoaded" class="task-list-container">
  <div class="task-list-header">
    <h3>查核任務列表</h3>

    <!-- 篩選面板切換按鈕 -->
    <button class="filter-toggle-btn" (click)="toggleFilterPanel()" [class.active]="isFilterExpanded">
      <i class="fas fa-filter"></i> 篩選條件
      <i class="fas" [ngClass]="isFilterExpanded ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
    </button>
  </div>

  <!-- 篩選面板 -->
  <div class="filter-panel" *ngIf="isFilterExpanded">
    <div class="filter-content">

      <!-- 第一排：時間區間和關鍵字搜尋 -->
      <div class="filter-row">
        <div class="filter-group">
          <div class="time-range-header">
            <label>時間區間:</label>
            <!-- 快捷時間段 -->
            <div class="quick-date-buttons">
              <button type="button" class="quick-date-btn" (click)="setQuickDateRange('thisMonth')">本月</button>
              <button type="button" class="quick-date-btn" (click)="setQuickDateRange('thisQuarter')">本季</button>
              <button type="button" class="quick-date-btn" (click)="setQuickDateRange('thisYear')">本年</button>
              <button type="button" class="quick-date-btn" (click)="setQuickDateRange('last30Days')">近30天</button>
              <button type="button" class="quick-date-btn" (click)="setQuickDateRange('last90Days')">近90天</button>
            </div>
          </div>
          <div class="date-range-group">
            <input
              type="date"
              [(ngModel)]="filterCriteria.dateRange.startDate"
              (change)="onDateRangeChange()"
              placeholder="開始日期">
            <span>至</span>
            <input
              type="date"
              [(ngModel)]="filterCriteria.dateRange.endDate"
              (change)="onDateRangeChange()"
              placeholder="結束日期">
          </div>
        </div>

        <div class="filter-group">
          <label>關鍵字搜尋:</label>
          <input
            type="text"
            [(ngModel)]="filterCriteria.keyword"
            (input)="onKeywordSearch()"
            placeholder="搜尋任務名稱或主題"
            class="keyword-input">
        </div>
      </div>

      <!-- 第二排：建別群組和狀態篩選 -->
      <div class="filter-row">
        <div class="filter-group">
          <label for="departmentFilter">建別群組:</label>
          <select 
            id="departmentFilter" 
            [(ngModel)]="selectedDepartmentFilter" 
            (change)="onDepartmentDropdownChange()"
            class="form-select">
            <option value="">全部</option>
            <option *ngFor="let dept of availableDepartments" [value]="dept">{{ dept }}</option>
          </select>
        </div>

        <div class="filter-group">
          <label for="statusFilter">狀態:</label>
          <select 
            id="statusFilter" 
            [(ngModel)]="selectedFilterStatus" 
            (change)="onStatusDropdownChange()"
            class="form-select">
            <option value="">全部</option>
            <option *ngFor="let status of availableStatuses" [value]="status">{{ status }}</option>
          </select>
        </div>
      </div>

      <!-- 篩選控制按鈕 -->
      <div class="filter-actions">
        <button class="btn btn-primary" (click)="applyFilters()">
          <i class="fas fa-search"></i> 應用篩選
        </button>
        <button class="btn btn-secondary" (click)="clearFilters()">
          <i class="fas fa-times"></i> 清除篩選
        </button>
      </div>
    </div>
  </div>

  <div class="task-table-container">
    <table class="task-table">
      <thead>
        <tr>
          <th class="sortable" (click)="setSortCriteria('status')">
            狀態 <i class="fas" [ngClass]="getSortIcon('status')"></i>
          </th>
          <th class="sortable" (click)="setSortCriteria('topic')">
            主題 <i class="fas" [ngClass]="getSortIcon('topic')"></i>
          </th>
          <th class="sortable" (click)="setSortCriteria('title')">
            任務名稱 <i class="fas" [ngClass]="getSortIcon('title')"></i>
          </th>
          <th class="sortable" (click)="setSortCriteria('startDate')">
            起始日期 <i class="fas" [ngClass]="getSortIcon('startDate')"></i>
          </th>
          <th class="sortable" (click)="setSortCriteria('endDate')">
            結束日期 <i class="fas" [ngClass]="getSortIcon('endDate')"></i>
          </th>
          <th>法規數/法條數</th>
          <th class="sortable" (click)="setSortCriteria('assign_to')">
            鑑別群組 <i class="fas" [ngClass]="getSortIcon('assign_to')"></i>
          </th>
          <th class="sortable" (click)="setSortCriteria('completionRate')">
            鑑別完成度 <i class="fas" [ngClass]="getSortIcon('completionRate')"></i>
          </th>
          <th>操作</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let task of availableTasks"
            class="task-row"
            [ngClass]="getTaskStatus(task).className"
             (click)="selectTask(task)"
           >
          <td>
            <span class="status-badge">{{ getTaskStatus(task).status }}</span>
          </td>
           <td>{{ task.topic }}</td>
          <td>{{ task.title }}</td>
          <td>{{ task.startDate | date:'yyyy-MM-dd' }}</td>
          <td>{{ task.endDate | date:'yyyy-MM-dd' }}</td>
          <td>{{ task.lawCount }} / {{ task.articleCount }}</td>
          <td>
            {{ task.assign_to }}</td>
          <!-- <td>
            <div class="progress-container">
              <div class="progress-bar">
                <div class="progress-indicator" [style.width.%]="task.completionRate"></div>
              </div>
              <span class="progress-text">{{ task.completionRate }}%</span>
            </div>
          </td> -->
          <td>
            <div class="compliance-rates-container">
              <!-- <div class="compliance-summary">
                <span class="rate-item compliant">
                  符合: {{ task.complianceRates?.complianceCount || 0 }} ({{ task.complianceRates?.complianceRate || 0 }}%)
                </span>
                <span class="rate-item non-compliant">
                  不符合: {{ task.complianceRates?.nonComplianceCount || 0 }} ({{ task.complianceRates?.nonComplianceRate || 0 }}%)
                </span>
                <span class="rate-item irrelevant">
                  無關: {{ task.complianceRates?.irrelevantCount || 0 }} ({{ task.complianceRates?.irrelevantRate || 0 }}%)
                </span>
                <span class="rate-item pending">
                  未鑑別: {{ task.complianceRates?.pendingCount || 0 }} ({{ task.complianceRates?.pendingRate || 0 }}%)
                </span>
              </div> -->
              <div class="compliance-progress-bar"
                   title="符合:{{ task.complianceRates?.complianceCount || 0 }}筆 | 不符合:{{ task.complianceRates?.nonComplianceCount || 0 }}筆 | 無關:{{ task.complianceRates?.irrelevantCount || 0 }}筆 | 未鑑別:{{ task.complianceRates?.pendingCount || 0 }}筆">
                <div class="segment compliant" [style.width.%]="task.complianceRates?.complianceRate || 0"></div>
                <div class="segment non-compliant" [style.width.%]="task.complianceRates?.nonComplianceRate || 0"></div>
                <div class="segment irrelevant" [style.width.%]="task.complianceRates?.irrelevantRate || 0"></div>
                <div class="segment pending" [style.width.%]="task.complianceRates?.pendingRate || 0"></div>
              </div>
               <span class="progress-text">{{ task.completionRate }}%</span>
            </div>
          </td>
          <td>
            <!-- 添加 $event.stopPropagation() 來阻止事件冒泡 -->
            <button class="edit-btn" (click)="onEditTask(task); $event.stopPropagation()">
              <i class="fa-solid fa-pen-to-square"></i> 編輯
            </button>
            <button class="delete-btn" (click)="onDeleteTask(task); $event.stopPropagation()">
              <i class="fa-solid fa-trash"></i> 刪除
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- 如果沒有任務顯示提示訊息 -->
  <div *ngIf="availableTasks.length === 0" class="no-tasks-message">
    <div *ngIf="hasActiveFilters(); else noTasksDefault">
      沒有符合篩選條件的查核任務
    </div>
    <ng-template #noTasksDefault>
      沒有可用的查核任務
    </ng-template>
  </div>
</div>

<!-- Loading 動畫指示器 (當 loadData 正在執行時顯示) -->
<div *ngIf="isLoading" class="loading-indicator">
  <div class="spinner"></div>
  <p>資料載入中，請稍候...</p>
</div>

<!-- 查核內容頁面 (當選中任務後顯示) -->
<div *ngIf="dataLoaded">
  <!-- 返回按鈕 -->
  <!-- <div class="back-to-list">
    <button class="btn back-btn" (click)="backToTaskList()">
      <i class="fa-solid fa-arrow-left"></i> 返回任務列表
    </button>
  </div> -->

  <!-- 任務摘要資訊區塊 -->
  <div class="task-summary-container">
    <div class="task-header">
     <div class="task-title">
  <h2>{{ selectedTitleFilter}}</h2>
   <button style="margin-left: 10px;" class="btn back-btn" (click)="backToTaskList()">
      <i class="fa-solid fa-arrow-left"></i> 返回任務列表
    </button>

  <div class="back-btn-container">

   <button class="btn export-excel" (click)="exportToExcel()">
    <i class="fas fa-download"></i>
  匯出 Excel
</button>

   <!-- 任務結案按鈕，只在完成度為100%且status不等於review時顯示 -->
   <button
     *ngIf="completionRate === 100 && selectedTask?.status !== 'review' && selectedTask?.status !== 'approved'"
     class="btn close-task-btn"
     (click)="onCloseTask()">
     <i class="fas fa-check-circle"></i>
     送出審核
   </button>

   <!-- 審核按鈕組，只在status等於review時顯示 -->
   <div *ngIf="selectedTask?.status === 'review'" class="review-buttons-group">
     <button
       class="btn review-approve-btn"
       (click)="onReviewApprove()">
       <i class="fas fa-check"></i>
       審核通過
     </button>
     <button
       class="btn review-reject-btn"
       (click)="onReviewReject()">
       <i class="fas fa-times"></i>
       審核不通過
     </button>
   </div>
  </div>
</div>
      <div class="task-meta">
        <!-- <span>建立日期: {{ taskCreationDate | date:'yyyy-MM-dd' }}</span> -->
        <span>負責部門: {{ taskAssignee }}</span>
        <!-- 添加折疊/展開按鈕 -->
        <button class="toggle-stats-btn" (click)="toggleStatsVisibility()">
          <i class="fa-solid" [ngClass]="isStatsVisible ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
        </button>
      </div>
    </div>

    <!-- 添加 [class.collapsed] 綁定，控制統計區域的顯示/隱藏 -->
    <div class="compliance-stats" [class.collapsed]="!isStatsVisible">
      <div class="stat-item"[class.active]="selectedStatusFilter === 'all'"
       (click)="filterByStatus('all')">
        <span class="stat-label">總條數</span>
        <span class="stat-value">{{ totalArticles }}</span>
        <span class="stat-percent">{{ getPercentage(totalArticles, totalArticles) }}%</span>
      </div>
      <div class="stat-item compliant"  [class.active]="selectedStatusFilter === 'compliance'"
       (click)="filterByStatus('compliance')">
        <span class="stat-label">符合</span>
        <span class="stat-value">{{ compliantCount }}</span>
        <span class="stat-percent">{{ getPercentage(compliantCount, totalArticles) }}%</span>
      </div>
      <div class="stat-item non-compliant" [class.active]="selectedStatusFilter === 'non_compliance'"
       (click)="filterByStatus('non_compliance')">
        <span class="stat-label">不符合</span>
        <span class="stat-value">{{ nonCompliantCount }}</span>
        <span class="stat-percent">{{ getPercentage(nonCompliantCount, totalArticles) }}%</span>
      </div>
      <div class="stat-item irrelevant" [class.active]="selectedStatusFilter === 'irrelevant'"
       (click)="filterByStatus('irrelevant')">
        <span class="stat-label">不適用</span>
        <span class="stat-value">{{ irrelevantCount }}</span>
        <span class="stat-percent">{{ getPercentage(irrelevantCount, totalArticles) }}%</span>
      </div>
      <div class="stat-item pending" [class.active]="selectedStatusFilter === 'pending'"
       (click)="filterByStatus('pending')">
        <span class="stat-label">尚未判別</span>
        <span class="stat-value">{{ pendingCount }}</span>
        <span class="stat-percent">{{ getPercentage(pendingCount, totalArticles) }}%</span>
      </div>

      <div class="completion-bar">
        <div class="completion-indicator" [style.width.%]="completionRate"></div>
        <span class="completion-text">完成度: {{ completionRate }}%</span>

        <!-- 25% 寶箱 -->
        <div class="treasure-box treasure-25"
             [class.unlocked]="completionRate >= 25"
             [class.collected]="treasureCollected[0]"
             [class.disabled]="completionRate < 25 && !treasureCollected[0]"
             (click)="collectTreasure(0, 25)"
             >
          <i class="fa-solid fa-gift"></i>
        </div>

        <!-- 50% 寶箱 -->
<div class="treasure-box treasure-50"
     [class.unlocked]="completionRate >= 50"
     [class.collected]="treasureCollected[1]"
     [class.disabled]="completionRate < 50 && !treasureCollected[1]"
     (click)="collectTreasure(1, 50)">
  <i class="fa-solid fa-gift"></i>
</div>

<!-- 75% 寶箱 -->
<div class="treasure-box treasure-75"
     [class.unlocked]="completionRate >= 75"
     [class.collected]="treasureCollected[2]"
     [class.disabled]="completionRate < 75 && !treasureCollected[2]"
     (click)="collectTreasure(2, 75)">
  <i class="fa-solid fa-gift"></i>
</div>

<!-- 100% 寶箱 -->
<div class="treasure-box treasure-100"
     [class.unlocked]="completionRate >= 100"
     [class.collected]="treasureCollected[3]"
     [class.disabled]="completionRate < 100 && !treasureCollected[3]"
     (click)="collectTreasure(3, 100)">
  <i class="fa-solid fa-trophy"></i>
</div>
      </div>
    </div>
  </div>

  <div class="treasure-modal" *ngIf="showTreasureModal" (click)="onModalBackdropClick($event)">
  <div class="treasure-modal-content" [style.border-color]="modalBorderColor">
    <div class="treasure-modal-header">
      <h3>{{ treasureModalTitle }}</h3>
      <button class="treasure-modal-close" (click)="closeTreasureModal()">&times;</button>
    </div>
    <div class="treasure-modal-body">
      <div class="treasure-icon">
        <i class="fa-solid {{ treasureModalIcon }}"></i>
      </div>

      <!-- 載入中狀態 -->
      <div class="treasure-loading" *ngIf="treasureContentLoading">
        <div class="spinner"></div>
        <p>正在開啟寶箱...</p>
      </div>

      <!-- 內容顯示區 -->
      <div class="treasure-message" *ngIf="!treasureContentLoading" [innerHTML]="treasureModalContent"></div>
    </div>
    <div class="treasure-modal-footer">
      <button class="treasure-modal-ok" (click)="closeTreasureModal()">太棒了！</button>
    </div>
  </div>
</div>

  <!-- 其餘查核內容 (原本的模板內容) -->
  <div class="compliance-container">
    <!-- 左側過濾器和法規列表 -->
    <div class="sidebar">
      <!-- 法規列表 - 改為垂直列表 -->
      <div class="law-list-section">
        <h3>法規列表</h3>
        <ul class="law-list">
          <li *ngFor="let law of lawsWithCount"
              [class.active]="law.law_id === selected_law_id"
              (click)="selectType(law.law_id)">
            <div class="law-item">
              <span class="law-name">{{ law.law_id }}</span>
              <span class="law-count">({{ law.cnt }})</span>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <!-- 右側法規條文內容 -->
    <div class="main-content">
      <!-- 法規詳情展示區域 -->
      <div class="law-details-container" *ngIf="selectedLawDetails">
        <div class="law-info">
          <h2>
            <a style="color: black;" [href]="selectedLawDetails.laws.law_url" target="_blank">
              {{ selectedLawDetails.laws.law_name || '未設定' }}
            </a>
          </h2>
          <div class="law-meta">
            <p><strong>發布日期:</strong> {{ selectedLawDetails.laws.law_publish_date }}</p>
            <p><strong>修改日期:</strong> {{ selectedLawDetails.laws.law_modified_date }}</p>
            <p><strong>分類:</strong> {{ selectedLawDetails.laws.law_category }}</p>
            <p><strong>層級:</strong> {{ selectedLawDetails.laws.law_hierarchy }}</p>
          </div>
        </div>

        <!-- 法條內容上方的工具列 -->
        <div class="law-tools">
          <div class="tools-group">
            <label for="batchSetStatus">批次設定未判別項目為: </label>
            <select id="batchSetStatus" [(ngModel)]="batchStatus" class="batch-select">
              <option value="" disabled selected>請選擇...</option>
              <option value="compliance">符合</option>
              <option value="non_compliance">不符合</option>
              <option value="irrelevant">不適用</option>
            </select>
            <button class="btn batch-apply" (click)="applyBatchStatus()">
              <i class="fa-solid fa-check-double"></i> 套用
            </button>
          </div>

          <!-- 新增批次寫入目前狀態功能 -->
          <div class="tools-group">
            <label for="batchCurrentStatus">批次寫入目前狀態: </label>
            <input type="text" id="batchCurrentStatus" [(ngModel)]="batchCurrentStatus"
                   class="batch-input" placeholder="輸入目前狀態說明...">
            <button class="btn batch-status-apply" (click)="applyBatchCurrentStatus()">
              <i class="fa-solid fa-pen-to-square"></i> 套用
            </button>
          </div>

          <div class="buttons-group">
            <button class="btn ai-analyze" (click)="runAiAnalysis()">
              <i class="fa-solid fa-robot"></i> AI智能判斷
            </button>

            <button class="btn clear-all" (click)="clearAllResults()" [disabled]="isClearingAll">
              <ng-container *ngIf="isClearingAll; else normalContent">
                <i class="fa fa-spinner fa-spin"></i> 清空中...
              </ng-container>
              <ng-template #normalContent>
                <i class="fa-solid fa-trash"></i> 清空判別結果
              </ng-template>
            </button>
          </div>
        </div>

        <!-- 法規 Summary 區塊 -->
        <div class="law-summary-container">
          <h4>法規 Summary</h4>
          <div class="summary-content">
            <textarea
              [(ngModel)]="selectedLawSummary"
              placeholder="請輸入此法規的整體評估..."
              rows="6"
              class="form-control summary-textarea"
              [disabled]="isSummaryLoading"
              (keydown)="onSummaryKeyDown($event)">
            </textarea>
            <div class="summary-actions">
              <button
                (click)="saveLawSummary()"
                [disabled]="isSummaryLoading"
                class="btn btn-primary summary-save-btn">
                <i class="fa fa-save" *ngIf="!isSummaryLoading"></i>
                <i class="fa fa-spinner fa-spin" *ngIf="isSummaryLoading"></i>
                儲存 Summary
              </button>
            </div>
            <div class="summary-info" *ngIf="summaryLastUpdated">
              <small class="text-muted">
                最後更新：{{summaryLastUpdated}} by {{summaryUpdatedBy}}
              </small>
            </div>
          </div>
        </div>

        <!-- 法條內容 -->
        <h3>法條內容</h3>
        <div *ngIf="selectedLawArticles && selectedLawArticles.length > 0; else noArticles">
          <div *ngFor="let article of selectedLawArticles" >

             <div *ngIf="article.article_type === 'C'" class="chapter-title">
            <h4>{{ article.article_content }}</h4>
          </div>


            <div *ngIf="article.article_type === 'A'" class="article-item">
            <div class="article-header">
              <p><strong>{{ article.article_no }}</strong></p>
            </div>

            <!-- 法條內容 -->
            <p [innerHTML]="formatArticleContent(article.article_content)"></p>

            <!-- 合規性結果按鈕 -->
            <div class="compliance-result-buttons">
              <button class="btn compliant"
                      [class.active]="article.compliance_result?.result?.compliance === 'V'"
                      (click)="updateComplianceResult(article, 'compliance', 'V')">
                符合
              </button>

              <button class="btn non-compliant"
                      [class.active]="article.compliance_result?.result?.non_compliance === 'V'"
                      (click)="updateComplianceResult(article, 'non_compliance', 'V')">
                不符合
              </button>

              <button class="btn irrelevant"
                      [class.active]="article.compliance_result?.result?.irrelevant === 'V'"
                      (click)="updateComplianceResult(article, 'irrelevant', 'V')">
                不適用
              </button>
            </div>

            <!-- 合規性狀態和更新日期 -->
            <div class="compliance-details" *ngIf="article.compliance_result">
              <div class="status-section">
                <label><strong>目前狀態:</strong></label>
                <textarea
                  [(ngModel)]="article.compliance_result.current_status"
                  (focus)="storeOriginalStatus(article)"
                  (blur)="checkStatusChanged(article)"
                  placeholder="輸入狀態說明..."
                  rows="2"
                  class="status-textarea">
                </textarea>
              </div>
              <div class="update-date">
                <label><strong>最後更新日期:</strong> {{ article.compliance_result.last_updated_date || '未更新' }}</label>
              </div>
            </div>
          </div>
            <hr />
          </div>
        </div>
        <ng-template #noArticles>
          <p>無法條內容</p>
        </ng-template>
      </div>

      <!-- 無資料顯示 -->
      <div class="no-data-message" *ngIf="!selectedLawDetails">
        <p>請從左側選擇法規查看內容</p>
      </div>
    </div>
  </div>
</div>

<!-- 無資料提示 -->
<div *ngIf="!tasksLoaded && !dataLoaded" class="no-data-message">
  <p>請選擇公司和主題，然後點擊「載入任務列表」按鈕</p>
</div>

<!-- 添加載入中動畫覆蓋層 -->
<!-- <div class="loading-overlay" *ngIf="isTaskLoading">
  <div class="loading-spinner">
    <i class="fa-solid fa-circle-notch fa-spin"></i>
    <p>資料載入中，請稍候...</p>
  </div>
</div> -->

<!-- 審核意見彈出視窗 -->
<div *ngIf="showReviewModal" class="review-modal-overlay" (click)="closeReviewModal()">
  <div class="review-modal-content" (click)="$event.stopPropagation()">
    <div class="review-modal-header">
      <h3>{{ reviewModalTitle }}</h3>
      <button class="close-btn" (click)="closeReviewModal()">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="review-modal-body">
      <div class="review-info">
        <p><strong>任務名稱：</strong>{{ selectedTask?.title || selectedTask?.topic }}</p>
        <p><strong>負責部門：</strong>{{ selectedTask?.assign_to }}</p>
      </div>

      <!-- 改善項目選項，只在審核通過且有不符合項目時顯示 -->
      <div *ngIf="reviewType === 'approve' && nonComplianceCount > 0" class="improvement-items-section">
        <div class="improvement-checkbox-container">
          <label class="improvement-checkbox-label">
            <input
              type="checkbox"
              [(ngModel)]="includeImprovementItems"
              class="improvement-checkbox">
            <span class="checkbox-text">
              是否要將 <strong>{{ nonComplianceCount }}</strong> 筆判別為不符合的項目一併拋轉到改善項目中
            </span>
          </label>
        </div>
      </div>

      <div class="review-comment-section">
        <label for="reviewComment">審核意見：</label>
        <textarea
          id="reviewComment"
          [(ngModel)]="reviewComment"
          placeholder="請輸入審核意見..."
          rows="4"
          class="review-comment-textarea">
        </textarea>
      </div>
    </div>

    <div class="review-modal-footer">
      <button class="btn cancel-btn" (click)="closeReviewModal()">
        取消
      </button>
      <button
        class="btn confirm-btn"
        [class]="reviewType === 'approve' ? 'approve-btn' : 'reject-btn'"
        (click)="confirmReview()"
        [disabled]="!reviewComment.trim()">
        <i class="fas" [class]="reviewType === 'approve' ? 'fa-check' : 'fa-times'"></i>
        {{ reviewType === 'approve' ? '確認通過' : '確認不通過' }}
      </button>
    </div>
  </div>
</div>
